export const CATEGORY_LABELS: Record<string, string> = {
  'comece-aqui': 'Comece aqui',
  acesso: 'Acesso',
  hoje: 'Hoje',
  diagnostico: 'Diagnóstico',
  desenvolvimento: 'Meu Desenvolvimento',
  plano: 'Plano',
  jornada: 'Jornada',
  jornadas: 'Jornadas',
  formacoes: 'Formações',
  treinamentos: 'Treinamentos',
  evidencias: 'Evidências',
  mentorias: 'Mentorias',
  progresso: 'Progresso',
  conceitos: 'Conceitos',
  mentorados: 'Mentorados',
  'visao-360': 'Visão 360',
  acompanhamento: 'Acompanhamento',
  'jornada-formacoes': 'Jornada e Formações',
  pessoas: 'Pessoas',
  membros: 'Membros',
  metodologia: 'Metodologia',
  operacao: 'Operação',
  configuracoes: 'Configurações',
};

export function categoryLabel(category: string) {
  return CATEGORY_LABELS[category] ?? category.replaceAll('-', ' ');
}
